<template lang="pug">
v-flex 
  v-card
    v-card-title Correo remitentes
      v-spacer
      v-text-field(v-model='search' append-icon='fa-search' label='Buscar correo remitente' single-line hide-details)
      v-dialog(v-model='correo_remitente.dialog' max-width='500px')
        template(v-slot:activator='{ on }')
          v-btn.mb-2(color='primary' dark v-on='on' @click='clearForm()') Añadir
        v-card
          v-card-title
            span.headline {{ title }}
          v-card-text
            v-container(grid-list-md)
              v-layout(wrap)
                v-flex(xs12 sm6)
                  v-text-field(v-model='datos.emisor' label='Emisor' )
                v-flex(xs12 sm6)
                  v-text-field(v-model='datos.correo_remitente' label='Correo electrónico')
          v-card-actions
            v-spacer
            v-btn(color='primary' @click='save()') {{ titleButton }}
    v-data-table.elevation-1(:headers='headers' :items='registro_correo_remitente' :search='search')
      template(v-slot:items='props')
        td {{ props.item.emisor }}
        td {{ props.item.correo_remitente }}
        td.justify-center.layout.px-0
          v-btn(color='secondary' icon @click='editItem(props.item.key)')
            v-icon(small) far fa-edit
          v-btn(color='secondary' icon @click='deleteItem(props.item.key)')
            v-icon(small) far fa-trash-alt
</template>
<script>
import {mapActions, mapGetters, mapState, mapMutations} from 'vuex'
export default {
  data: () => ({
    search: '',
    headers: [
      { text: 'Lista de Tipo de emisores', align: 'left', value: 'emisor'},
      { text: 'Correo electrónico', value: 'correo_electronico'},
      { text: 'Actions', value: 'titlename', sortable: false }
    ],
    record: [],
  }),
    methods: {
      ...mapActions({
        editItem: 'correo_remitente/get',
        deleteItem: 'correo_remitente/clean',
        save: 'correo_remitente/add',
        clearForm: 'correo_remitente/clearForm',
      }),
    },
    computed: {
      title() { return this.correo_remitente.selectedKey == '' ? 'Registrar' : 'Crear' },
      titleButton() { return this.correo_remitente.selectedKey == "" ? 'Guardar' : 'Editar' },
      ...mapGetters({
        registro_correo_remitente: 'correo_remitente/registro',
      }),
       ...mapState({
      datos: state=> state.correo_remitente.datos,
      correo_remitente :state=> state.correo_remitente,
    })
  }
}
</script>
